@if (visible()) {
    <p-message [severity]="severity()" [icon]="icon()" [size]="size()" [closable]="closeable()"
        (onClose)="closed.emit()">
        <div class="flex flex-1 gap-small align-items-center">
            @if (showSeverityText()) {
                <div class="font-bold mr-2">{{ 'messages.severity.' + severity() | translate }}</div>
            }

            @if (messageText()) {
                {{ messageText() }}
            }

            <ng-content></ng-content>
        </div>
    </p-message>
}
